import { configureStore } from "@reduxjs/toolkit";
import CalendarReducer from "./CalendarSlice";
import ClientReducer from "./ClientSlice";
import InvoiceReducer from "./InvoiceSlice";
import TransactionReducer from "./TransactionSlice";
import LogReducer from "./LogSlice";
import PreferenceReducer from "./PreferenceSlice";
import NotificationReducer from "./NotificationSlice";
import QuickReportReducer from "./QuickReportSlice";
import ConnectionReducer from "./ConnectionSlice";
import CompanyReducer from "./CompanySlice";
import SubscriptionReducer from "./SubscriptionSlice";
import StripeSubscriptionReducer from "./StripeSlice";
import SystemJobsReducer from "./SystemJobsSlice";
import SMSReducer from "./SMSSlice";

export const store = configureStore({
  reducer: {
    calendarReducer: CalendarReducer,
    clientReducer: ClientReducer,
    invoiceReducer: InvoiceReducer,
    transactionReducer: TransactionReducer,
    logReducer: LogReducer,
    preferenceReducer: PreferenceReducer,
    notificationReducer: NotificationReducer,
    quickReportReducer: QuickReportReducer,
    connectionReducer: ConnectionReducer,
    companyReducer: CompanyReducer,
    subscriptionReducer: SubscriptionReducer,
    stripeSubscriptionReducer: StripeSubscriptionReducer,
    systemJobsReducer: SystemJobsReducer,
    smsReducer: SMSReducer,
  },
});

export default store;
